import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';
import { Lock } from 'lucide-react';

const AdminLogin = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Simple password check - you can change this password
    const correctPassword = 'ChristieKieran2026';

    if (password === correctPassword) {
      onLogin();
      sessionStorage.setItem('adminAuthenticated', 'true');
    } else {
      setError('Incorrect password. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ivory-50 flex items-center justify-center px-4">
      <Card className="w-full max-w-md border-lightskyblue-200 shadow-2xl">
        <CardHeader className="bg-gradient-to-r from-lightskyblue-600 to-lightskyblue-500 text-white rounded-t-lg p-8">
          <div className="text-center">
            <Lock className="w-12 h-12 mx-auto mb-4" />
            <CardTitle className="font-serif text-3xl">Admin Access</CardTitle>
            <p className="text-lightskyblue-50 mt-2 font-body">Christie & Kieran's Wedding</p>
          </div>
        </CardHeader>
        <CardContent className="p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="password" className="text-lightskyblue-800 font-serif text-lg">
                Admin Password
              </Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter admin password"
                className="border-2 border-lightskyblue-300 focus:border-gold-400 focus:ring-gold-400 rounded-md font-body"
                required
                autoFocus
              />
              {error && (
                <p className="text-sm text-red-600 mt-2">{error}</p>
              )}
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-lightskyblue-600 to-lightskyblue-500 hover:from-lightskyblue-700 hover:to-lightskyblue-600 text-white py-6 text-lg font-serif border-2 border-gold-400 shadow-lg"
            >
              {loading ? 'Checking...' : 'Access Dashboard'}
            </Button>

            <p className="text-xs text-lightskyblue-600 text-center font-body italic mt-4">
              If you've forgotten the password, please contact Christie or Kieran
            </p>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;